"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popup = void 0;
var react_1 = __importDefault(require("react"));
var _1 = require(".");
var Popup = function (_a) {
    var children = _a.children, title = _a.title, onClose = _a.onClose, _b = _a.position, position = _b === void 0 ? "center" : _b, _c = _a.overlay, overlay = _c === void 0 ? true : _c, _d = _a.hideHeader, hideHeader = _d === void 0 ? false : _d, wrapperStyle = _a.wrapperStyle, overlayStyle = _a.overlayStyle;
    var headerWrapper = function (body) { return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "absolute right-0 p-1" },
            react_1.default.createElement("a", { className: "cursor-pointer", onClick: onClose },
                react_1.default.createElement(_1.InlineIcon, { name: "close", className: "w-5 text-grey-darkest hover:text-red-dark" }))),
        react_1.default.createElement("div", { className: "PopupBodyWrapper pt-4" },
            react_1.default.createElement("div", { className: "PopupBody" },
                react_1.default.createElement("div", { className: "mr-4 px-4" },
                    react_1.default.createElement(_1.Header, null, title)),
                body)))); };
    return (react_1.default.createElement(_1.PopupBase, { onClose: onClose, overlay: overlay, position: position, wrapperStyle: wrapperStyle, overlayStyle: overlayStyle }, hideHeader ? children : headerWrapper(children)));
};
exports.Popup = Popup;
